export enum DocumentSendingProfile {
    MAIL = 'mail',
    EDOCUMENT = 'e_document',
    POST = 'post',
}